@if (labelCols != null) {
    <div [ngClass]="{'form-group row': labelCols > 0}">
        @if (labelCols > 0) {
            <label class="col-form-label" [class]="labelClass" [for]="id">{{ label }}</label>
        }
        <div [class]="inputColsClass">
            <ng-container [ngTemplateOutlet]="numberInput" />
        </div>
    </div>
} @else {
    <div [ngClass]="{'mb-3': label.length > 0}">
        @if (label.length > 0) {
            <div class="d-flex justify-content-between">
                <label class="form-label" [class]="labelClass" [for]="id">{{ label }}</label>
                @if (information) {
                    <app-popover-icon class="ms-3" [popover]="information" />
                }
            </div>
        }
        <ng-container [ngTemplateOutlet]="numberInput" />
    </div>
}

<ng-template #numberInput>
    <div class="input-group">
        <input
            [name]="name"
            #htmlInputElement
            type="text"
            class="form-control"
            [formControl]="formControl"
            [id]="id"
            [ngClass]="{'input-saved': state === 'updated', 'input-error': state === 'error'}"
            [class.is-invalid]="ngControl.invalid && ngControl.touched"
            (focus)="onFocus($event)"
            (blur)="onBlur()"
            (keydown)="onKeyDown($event)"
            [autocomplete]="autocomplete"
            [attr.maxlength]="maxlength" />

        @if (descriptor) {
            <span class="input-group-text">
                {{ descriptor }}
            </span>
        }
    </div>

    @if (ngControl.control != null) {
        <app-control-messages [control]="ngControl.control" />
    }
</ng-template>
